import React from 'react';

import { clsx } from 'clsx';

import { AboutUsCard } from 'src/types';

import styles from './Card.scss';

const Card = ({ card }: { card: AboutUsCard }) => {
  return (
    <div className={styles.border} id={card.id}>
      <div className={clsx(styles.cardBackground, styles.blackBackground)} />
      <div className={clsx(styles.cardBackground, styles.cardContainer)}>
        <span className={styles.label}>{card.label}</span>
        <div className={styles.cardTitle} dangerouslySetInnerHTML={{ __html: card.title }} />
        <div className={styles.cardText} dangerouslySetInnerHTML={{ __html: card.text }} />
      </div>
    </div>
  );
};

export default Card;
